const INITIAL_VALUES = {
  year: new Date().getFullYear(),
  chain: null,
  percentage: '',
};

export default INITIAL_VALUES;
